/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Error Icon component.
 */
export const SystemErrorIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 7V13.3792' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M12 14.5283V16.2919' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <circle cx='12' cy='12' r='10' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default SystemErrorIcon;
